/* eslint-disable react/prop-types */
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import { useEffect, useMemo, useRef, useState } from "react";
import { API_ROUTES, PaperComponent } from "../../utils/constants";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { AlertState } from "states";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { DicBoTieuChiState } from "states";

const PrintPhieuChamDiem = ({ data, open, onClose }) => {
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const toolBarRef = useRef(null);
  const setAlert = useSetRecoilState(AlertState);
  const listBoTieuChiNhom = useRecoilValue(DicBoTieuChiState);
  const axiosPrivateInstance = useAxiosPrivate();
  const [printContent, setPrintContent] = useState("");
  const [sanPham, setSanPham] = useState();
  const [dataBoTieuChi, setBoTieuChi] = useState([]); // danh sách bộ tiêu chí đã chia nhóm -nhóm bộ
  const [dataChamDiem, setDataChamDiem] = useState(); //lấy hồ sơ chấm điểm trả về thông tin các điểm đã chấm trước đó
  const id = useMemo(() => data?.id, [data]);
  const thanhvien = useMemo(() => data?.thanhvien, [data]);
  const tenThanhvien = useMemo(() => data?.tenThanhvien, [data]);
  useEffect(() => {
    const fetchDataDangKySanPham = (id, thanhvien, listNhomTieuChi) => {
      axiosPrivateInstance
        .get(API_ROUTES.PHIEUDANGKY + "/" + id)
        .then((response) => {
          const data = response.data;
          setSanPham(data);
          if (data) {
            if (data.nhomsanpham_id) {
              axiosPrivateInstance
                .get(API_ROUTES.BOTIEUCHI, {
                  params: {
                    nhomsanpham: data.nhomsanpham_id,
                    nhom: true,
                  },
                })
                .then((res1) => {
                  const data = res1.data[0]?.nhom;
                  //bỏ rỗng
                  const nhomNoEmpty = data
                    .map((item) => ({
                      ...item,
                      nhombotieuchi: item.nhombotieuchi.filter(
                        (nbt) => nbt.botieuchi.length > 0
                      ),
                    }))
                    .filter((item) => item.nhombotieuchi.length > 0);
                  const dictNhomTieuChi = {};
                  nhomNoEmpty
                    ?.flatMap((item) =>
                      item?.nhombotieuchi?.length > 0 ? item?.nhombotieuchi : []
                    )
                    ?.forEach((item) => {
                      dictNhomTieuChi[item?.id] = {
                        id: item?.id,
                        ten: item?.ten,
                      };
                      let dicTieuChi = {};
                      let maxDiem = item?.botieuchi[0]?.diem;
                      item?.botieuchi?.forEach((tieuchi) => {
                        dicTieuChi[tieuchi?.id] = { ...tieuchi };
                        if (tieuchi?.diem > maxDiem) {
                          maxDiem = tieuchi?.diem;
                        }
                      });
                      dictNhomTieuChi[item?.id]["thangdiem"] = maxDiem;
                      dictNhomTieuChi[item?.id]["botieuchi"] = dicTieuChi;
                    });
                  setBoTieuChi(dictNhomTieuChi);
                });
            }
            if (
              data.chamdiem &&
              listNhomTieuChi &&
              thanhvien &&
              Object.values(listNhomTieuChi).length > 0
            ) {
              axiosPrivateInstance
                .get(API_ROUTES.GETHOSOCHAMDIEM, {
                  params: {
                    chamdiem: data.chamdiem[0]?.id,
                    thanhvien: thanhvien,
                  },
                })
                .then((res) => {
                  const listDataDiem = res.data?.data[0];
                  let dicDiem = {};
                  //thêm nhombotieuchi_id cho hồ sơ chấm điểm
                  listDataDiem?.botieuchi?.forEach(
                    (item) =>
                      (dicDiem[item?.botieuchi] = {
                        ...item,
                        nhomtieuchi_id:
                          listNhomTieuChi[item?.botieuchi]?.nhombotieuchi_id,
                      })
                  );
                  setDataChamDiem({
                    ...listDataDiem,
                    botieuchi: dicDiem,
                  });
                });
            }
          }
        })
        .catch((error) => {
          setAlert({
            alert: true,
            message: error?.message || "Lỗi!",
            type: "error",
          });
        });
    };
    if (
      id &&
      listBoTieuChiNhom &&
      Object.values(listBoTieuChiNhom).length > 0
    ) {
      fetchDataDangKySanPham(id, thanhvien, listBoTieuChiNhom);
    }
    return () => {
      setSanPham(null);
    };
  }, [id, thanhvien, listBoTieuChiNhom]);

  //   console.log(dataBoTieuChi);
  //   console.log(dataChamDiem);

  useEffect(() => {
    let body = "";
    const date = new Date();
    if (
      data &&
      data.id &&
      tenThanhvien &&
      dataChamDiem &&
      sanPham &&
      sanPham.id &&
      dataBoTieuChi
    ) {
      let resultTable = "";
      if (
        dataChamDiem?.botieuchi &&
        Object.values(dataChamDiem?.botieuchi).length > 0
      ) {
        resultTable = Object.values(dataChamDiem?.botieuchi)
          .map(
            (item) =>
              dataBoTieuChi[item?.nhomtieuchi_id]?.ten &&
              `<tr key={"nhomtieuchi_id_" + item?.id}>
            <td style="width:100%;">${
              dataBoTieuChi[item?.nhomtieuchi_id]?.ten
            }${
                dataBoTieuChi[item?.nhomtieuchi_id]?.botieuchi?.[
                  item?.botieuchi
                ]?.ten
                  ? `: ${
                      dataBoTieuChi[item?.nhomtieuchi_id]?.botieuchi?.[
                        item?.botieuchi
                      ]?.ten
                    }`
                  : ""
              }
            </td>
            <td>
              <p style="text-align:center;">
                ${dataBoTieuChi[item?.nhomtieuchi_id]?.thangdiem}
              </p>
            </td>
            <td>
              <p style="text-align:center;">${item?.diem}</p>
            </td>
            <td>&nbsp;</td>
          </tr>`
          )
          .join("");
        // return resultTable;
      }
      const totalNumber = Object.values(dataChamDiem?.botieuchi).reduce(
        (total, item) => total + item.diem,
        0
      );
      const totalPoint = `<tr key={"totalPoint"}>
            <td style="width:100%;font-weight:600;">Tổng điểm</td>
            <td>
              <p style="text-align:center;">&nbsp;</p>
            </td>
            <td>
              <p style="text-align:center;font-weight:600;">${totalNumber}</p>
            </td>
            <td>&nbsp;</td>
          </tr>`;
      //   console.log("resultTable", resultTable);
      body = `
  <p style="text-align:center;"><strong>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</strong></p>
  <p style="text-align:center;"><strong><u>Độc lập – Tự do – Hạnh phúc</u></strong></p>
  <p style="text-align:center;">&nbsp;</p>
  <p style="text-align:center;"><span style="background-color:white;color:black;"><strong>&nbsp;</strong></span><strong>PHIẾU ĐÁNH GIÁ SẢN PHẨM OCOP CỦA&nbsp;</strong></p>
  <p style="text-align:center;"><strong>THÀNH VIÊN HỘI ĐỒNG ĐÁNH GIÁ</strong></p>
  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Bộ sản phẩm</strong>:</p>
  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${
    sanPham?.bosanpham_ten
  }. Nhóm:&nbsp;${sanPham?.nhomsanpham_ten}</p>
  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Tên sản phẩm</strong>: ${
    sanPham?.sanpham_ten
  }</p>
  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Mã số sản phẩm:&nbsp;${
    sanPham?.sanpham_ma
  }</p>
  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Tên chủ thể sản xuất</strong>:&nbsp;${
    sanPham?.chuthe_ten
  }</p>
  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Số điện thoại:</p>
  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Địa chỉ:&nbsp;</p>
  <figure class="table">
  <table class="tableBorder">
  <tbody>
  <tr>
  <td>
  <p style="text-align:center;"><strong>Các tiêu chí</strong></p>
  </td>
  <td><p style="text-align:center;"><strong>Thang điểm (Điểm)</strong></p></td>
  <td><p style="text-align:center;"><strong>Chấm điểm</strong></p></td>
  <td><p style="text-align:center;"><strong>Ghi chú</strong></p></td>
  </tr>
  ${resultTable ? resultTable : ""}
  ${totalPoint ? totalPoint : ""}
  </tbody>
  </table>
  </figure>
  <p><i><strong>Ghi chú:</strong> Dấu sao là yêu cầu tối thiểu phải đạt theo các cấp độ sao</i>&nbsp;<i>(<strong>***</strong>&nbsp;-3 sao;&nbsp;<strong>****</strong>&nbsp;- 4 sao;&nbsp;<strong>*****</strong>- 5 sao)</i></p>
  <p>Ý kiến của người đánh giá:</p>
  <p>${
    dataChamDiem?.ykiendanhgia ? dataChamDiem?.ykiendanhgia : "Không có ý kiến."
  }</p>
  <p>&nbsp;</p>
  <figure class="tableSign">
  <table>
  <tbody>
  <tr>
  <td>
  <p>&nbsp;</p>
  </td>
  <td>
  <p style="text-align:center;"><span>Quảng Nam, ngày ${date
    .getDate()
    .toString()
    .padStart(2, "0")} tháng ${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")} năm ${date.getFullYear()}</span></p>
  <p style="text-align:center;"><strong>Người đánh giá</strong></p><p style="text-align:center;">(<i>Ký và ghi rõ họ tên</i>)</p>
  <p>&nbsp;</p>
  <p style="text-align:center;">${tenThanhvien}</p>
  </td>
  </tr>
  </tbody>
  </table>
  </figure>`;
    }
    setPrintContent(body);
  }, [data, tenThanhvien, dataChamDiem, dataBoTieuChi, sanPham]);
  const handelClear = () => {
    onClose();
  };
  const handleChangeEditor = (event, editor) => {
    const data = editor.getData();
    setPrintContent(data);
  };

  //   console.log(printContent);

  const handlePrint = () => {
    const printWindow = window.open("", "");
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = printContent;

    const figureElements = tempDiv.querySelectorAll("figure");
    const lastFigureElement = figureElements[figureElements.length - 1];
    if (lastFigureElement) {
      lastFigureElement.classList.remove("table");
      lastFigureElement.classList.add("tableSign");
    }
    printWindow.document.write(
      "<html><head><title>Phiếu đánh giá sản phẩm OCOP của thành viên hội đồng đánh giá</title>"
    );
    printWindow.document.write(
      "<style>@page { size: A4; margin: 20mm 12mm 20mm 12mm; } body { font-family: 'Times New Roman', Times, serif, Arial, sans-serif; } .tableSign{display:flex; justify-content:flex-end;} .table table{border-collapse: collapse;} .table td, .table th {border: 1px solid #121212;padding: 8px;}</style>"
    );
    printWindow.document.write("</head><body>");
    printWindow.document.write(tempDiv.innerHTML);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };
  //   console.log(printContent);
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "40rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          In phiếu đánh giá sản phẩm OCOP của thành viên hội đồng đánh giá
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ overflow: "auto" }}>
          <div className="bg-white">
            <div ref={toolBarRef} />
            <CKEditor
              editor={DecoupledEditor}
              data={printContent ? printContent : ""}
              onReady={(editor) => {
                if (toolBarRef.current) {
                  toolBarRef.current.appendChild(
                    editor.ui.view.toolbar.element
                  );
                }
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "450px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
              onChange={handleChangeEditor}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="contained"
            startIcon={<PrintIcon />}
            size="small"
            onClick={handlePrint}
            sx={{
              color: "#ffffff",
              float: "right",
              mr: 1,
              backgroundColor: "red",
              ":hover": {
                backgroundColor: "red",
              },
            }}
          >
            In
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{
              color: "#ffffff",
              float: "right",
              mr: 1,
              backgroundColor: "gray",
              ":hover": {
                backgroundColor: "gray",
              },
            }}
          >
            Đóng
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default PrintPhieuChamDiem;
